import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';

import AppContext from '../context/AppContext';
import { SettingsProvider } from '../context/SettingsContext';
import { ModalProvider } from '../context/ModalContext';

import Shell from '../components/Shell/Shell';
import UserMenu from '../components/Shell/UserMenu';
import ProtectedRoute from '../components/helpers/ProtectedRoute';

import ServiceReports from './ServiceReports';
import Customers from './Customers';
import Customer from './Customer';
import Events from './Events';
import Tasks from './Tasks';

import AddOrganizationModal from './modals/AddOrganizationModal';
import AddAssetToOrganizationModal from './modals/AddAssetToOrganizationModal';
import AddNewContentBlockModal from './modals/AddNewContentBlockModal';

import SelectLocationModal from '../modals/SelectLocationModal';
import QuickAddCategory from '../modals/QuickAddCategory';
import QuickAddTag from '../modals/QuickAddTag';
import DeleteModal from '../modals/DeleteModal';
import { useApp } from '../context/AppContextBeta';

const Admin = () => {
	const { refreshOrganization } = useApp();

	return (
		<SettingsProvider>
			<ModalProvider>
				<Shell
					navigation={[
						{ name: 'Dashboard', path: '/admin' },
						{ name: 'Task Check', path: '/admin/tasks' },

						{ name: 'Customers', path: '/admin/customers' },
						{ name: 'Export', path: '/admin/export' },
						{ name: 'Reports', path: '/admin/reports' },
						{ name: 'Events', path: '/admin/events' },
						{ name: 'Service Reports', path: '/admin/service-reports' },
					]}
					UserMenu={
						<UserMenu
							navigation={[
								{
									name: 'Back to Platform',
									onClick: () => {
										refreshOrganization();
									},
								},
								{ name: 'Sign Out', path: '/logout' },
							]}
						/>
					}
				>
					<ModalProvider>
						<Routes>
							<Route exact path="/admin/tasks" component={Tasks} />
							<ProtectedRoute
								exact
								path="/admin/reports"
								component={ServiceReports}
							/>
							<ProtectedRoute exact path="/admin" component={Customers} />
							<ProtectedRoute
								exact
								path="/admin/customers"
								component={Customers}
							/>
							<ProtectedRoute
								exact
								path="/admin/customers/:id"
								component={Customer}
							/>
							<ProtectedRoute exact path="/admin/events" component={Events} />
							<ProtectedRoute
								path="/admin/service-reports"
								component={ServiceReports}
							/>
							<ProtectedRoute
								exact
								path="/admin/service-report/:id"
								component={ServiceReports}
							/>
						</Routes>

						<AddOrganizationModal />
						<AddAssetToOrganizationModal />
						<AddNewContentBlockModal />

						<SelectLocationModal />
						<QuickAddCategory />
						<QuickAddTag />
						<DeleteModal />
					</ModalProvider>
				</Shell>
			</ModalProvider>
		</SettingsProvider>
	);
};

export default Admin;
